import { t } from "i18next";
import { herobg1 } from "../assets/Images";
import { herobg2 } from "../assets/Images";
import { herobg3 } from "../assets/Images";
import { herobg4 } from "../assets/Images";
import { MdOutlineFoodBank } from "react-icons/md";

import {

  clints,
  victory,
  Hands,
  Experiance,
  IoLogoWhatsapp,
  SiFacebook,

  FaHome,
  FaInfoCircle,
  FaHandsHelping,

  IoIosCreate,
  TbCategoryFilled,
  MdCreateNewFolder,

  IoPieChartSharp,
  FaTelegram,
  FaXTwitter,

} from "../components/utils/icons";

const HeroImages = [
  {
    id: 0,
    img: herobg1,
    titleAr: "أطباق اللحم الفاخرة",
    titleEn: "Premium Meat Dishes",
    subTitleAr: `مندي حياكم الملكي | تيس مشوي | خروف مفطح
ربع ونصف تيس مظبي | حنيذ طازج | زربيان فاخر
ألذ اللحوم المحضرة بلمسات يمنية أصيلة`,
    subTitleEn: `Hayakom Royal Mandi | Grilled Goat | Lamb Platter
Quarter & Half Madhbi Goat | Fresh Haneeth | Premium Zurbian
The tastiest meats prepared with authentic Yemeni flavors.`,
  },
  {
    id: 1,
    img: herobg2,
    titleAr: "دجاج حياكم",
    titleEn: "Hayakom Chicken",
    subTitleAr: `دجاج مظبي | دجاج مدفون | دجاج مندي
دجاج شواية | برياني دجاج | دجاج مظغوط
نكهات يمنية مميزة لعشاق أطباق الدجاج`,
    subTitleEn: `Chicken Madhbi | Chicken Madfoon | Chicken Mandi
Grilled Chicken | Chicken Biryani | Chicken Madhghoot
Distinct Yemeni flavors for chicken lovers.`,
  },
  {
    id: 2,
    img: herobg3,
    titleAr: "مأكولات بحرية شهية",
    titleEn: "Delicious Seafood",
    subTitleAr: `طبق حياكم البحري | سمك صيادية
جمبري متبل | سلمون مشوي طازج
تجربة بحرية غنية بالنكهات اليمنية`,
    subTitleEn: `Hayakom Seafood Platter | Sayadiya Fish
Seasoned Shrimp | Fresh Grilled Salmon
A seafood experience rich with Yemeni flavors.`,
  },
  {
    id: 3,
    img: herobg4,
    titleAr: "حلويات حياكم الخاصة",
    titleEn: "Hayakom Special Desserts",
    subTitleAr: `فته ملكية | معصوب بالقشطة والعسل
كنافة فاخرة | عسل سدر جبلي أصيل
تشكيلة حلويات يمنية بطابع فاخر`,
    subTitleEn: `Royal Fattah | Masoob with Cream & Honey
Luxury Kunafa | Authentic Mountain Sidr Honey
A selection of premium Yemeni desserts.`,
  },
];
const FotterText = {
  textEn:
    "Hayakom Restaurant for Mandi and Madhbi - We proudly serve authentic Yemeni mandi and madhbi dishes, prepared with premium ingredients and rich traditional flavors. Our mission is to offer you a memorable dining experience, whether you visit us at the restaurant or enjoy our fast delivery service.",
  textAr:
    "مطعم حياكم للمندي والمظبي - نقدم لكم أشهى أطباق المندي والمظبي اليمنية الأصيلة، المحضرة بأفضل المكونات والنكهات التقليدية الغنية. رسالتنا هي أن نمنحكم تجربة طعام مميزة لا تُنسى، سواء داخل المطعم أو عبر خدمة التوصيل السريعة.",
};
const navItems = [
  {
    id: 1,
    titleEn: "Home",
    titleAr: "الرئيسية",
    link: "/",
    icon: <FaHome />,
  },
  {
    id: 2,
    titleEn: "About Us",
    titleAr: "من نحن",
    link: "/AboutUs",
    icon: <FaInfoCircle />,
  },
  {
    id: 3,
    titleEn: "all Offers",
    titleAr: " جميع العروض",
    link: "/AllFeaturedMeals",
    icon: <FaHandsHelping />,
  },

  {
    id: 4,
    titleEn: "categories",
    titleAr: "الاصناف",
    link: "/MealsCategories",
    icon: <TbCategoryFilled />,
  },
  {
    id: 5,
    titleEn: "Meals",
    titleAr: "الوجبات",
    link: "/AllResturentMeals",
    icon: <MdOutlineFoodBank />,
  },
];
const countUpData = [
  {
    id: 1,
    titleEn: "Closed Cases",
    titleAr: "قضايا مغلقة",
    count: 201560,
    icon: victory,
  },
  {
    id: 2,
    titleEn: "Clients",
    titleAr: "عملاء",
    count: 300000,
    icon: clints,
  },
  {
    id: 3,
    titleEn: "Years Experience",
    titleAr: "سنوات الخبرة",
    count: 40,
    icon: Experiance,
  },
  {
    id: 4,
    titleEn: "Lawyers",
    titleAr: "محامين",
    count: 15,
    icon: Hands,
  },
];
const socialMedia = [
  {
    id: 1,
    titleAr: "فيسبوك",
    titleEn: "Facebook",
    icon: <SiFacebook />,
    link: "https://www.facebook.com/share/1955A3ygNU/",
  },
  {
    id: 2,
    titleAr: "واتس أب",
    titleEn: "WhatsApp",
    icon: <IoLogoWhatsapp />,
    link: "https://wa.me/201288841780",
  },

];

const localeTextGrid = {
  columnMenuSortAsc: t('Sort Ascending'), // ترتيب تصاعدي
  columnMenuSortDesc: t('Sort Descending'), // ترتيب تنازلي
  columnMenuUnsort: t('Unsort'), // إلغاء الترتيب
  columnMenuHideColumn: t('Hide Column'), // إخفاء العمود
  columnMenuManageColumns: t('Manage Columns'), // إدارة الأعمدة
  columnsPanelTextFieldLabel: t('Find column'), // البحث عن عمود
  columnsPanelTextFieldPlaceholder: t('Column title'), // عنوان العمود
  columnsPanelShowAllButton: t('Show all'), // عرض الكل
  columnsPanelHideAllButton: t('Hide all'), // إخفاء الكل
  columnsManagementReset: t('Reset'), // إعادة تعيين
  columnsManagementSearchTitle: t('Search'), // ترجمة كلمة "Search"

};


const AdminLinks = [
  {
    title: "Dashboard",
    links: [
      {
        name: "Dashboard",
        icon: <IoPieChartSharp />,
        linkSide: "admin",
      },
    ],
  },
  {
    title: "Meals",
    links: [ 
      {
        name: "Create Category",
        icon: <MdCreateNewFolder />,
        linkSide: "CreateCategoryPage",
      },
      {
        name: "Meal Categories",
        icon: <TbCategoryFilled />,
        linkSide: "DAllCategoriesPage",
      },
      {
        name: "All Meals",
        icon: <MdOutlineFoodBank />,
        linkSide: "DAllMealsPage",
      },
      {
        name: "Create Meal",
        icon: <IoIosCreate />,
        linkSide: "CreateMealPage",
      },
      {
        name: "Offers",
        icon: <MdOutlineFoodBank />,
        linkSide: "DAllFeaturedMealsPage",
      },
      {
        name: "Create Offer",
        icon: <IoIosCreate />,
        linkSide: "CreateFeaturedMealsPage",
      },
    
     
    ],
  },
  {
    title: "Reviews",
    links: [
      {
        name: "All Reviews",
        icon: <FaHandsHelping />,
        linkSide: "DAllReviewsPage",
      },
      {
        name: "Create Review",
        icon: <IoIosCreate />,
        linkSide: "CreateReviewPage",
      },
    ],
  },
];

const DeletButtonStyle={
  color: '#fff',
  background: 'linear-gradient(to right, #dc2626, #b91c1c, #dc2626)',
  boxShadow: '0 4px 6px -1px rgba(220, 38, 38, 0.5), 0 2px 4px -2px rgba(220, 38, 38, 0.5)',
  border: 'none',

  borderRadius:"5px",
  cursor: 'pointer',
  transition: 'all 0.3s ease',
}

const DeleteonMouseEnter= (e) => {
  e.currentTarget.style.background = 'linear-gradient(to bottom right, #dc2626, #b91c1c)';
}
const DeleteonMouseLeave=(e) => {
  e.currentTarget.style.background = 'linear-gradient(to right, #dc2626, #b91c1c, #dc2626)';
}
const DeleteonFocus=(e) => {
  e.currentTarget.style.outline = 'none';
  e.currentTarget.style.boxShadow = '0 0 0 4px rgba(185, 28, 28, 0.5)';
}
const DeleteonBlur=(e) => {
  e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(220, 38, 38, 0.5), 0 2px 4px -2px rgba(220, 38, 38, 0.5)';
}
const EditButtonStyle =
{
  color: '#fff',
  backgroundImage: 'linear-gradient(to right, #eab308, #ca8a04, #eab308)',
  boxShadow: '0 4px 6px -1px rgba(234, 179, 8, 0.5), 0 2px 4px -2px rgba(234, 179, 8, 0.5)',
  border: 'none',

 borderRadius:"5px",
  cursor: 'pointer',
  transition: 'all 0.3s ease',
}
const EditonMouseEnter=(e) => {
  e.currentTarget.style.background = 'linear-gradient(to bottom right, #eab308, #ca8a04)';
}
const EditonMouseLeave=(e) => {
  e.currentTarget.style.background = 'linear-gradient(to right, #eab308, #ca8a04, #eab308)';
}
const EditonFocus=(e) => {
  e.currentTarget.style.outline = 'none';
  e.currentTarget.style.boxShadow = '0 0 0 4px rgba(202, 138, 4, 0.5)';
}
const EditonBlur=(e) => {
  e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(234, 179, 8, 0.5), 0 2px 4px -2px rgba(234, 179, 8, 0.5)';
}

const ViewButtonStyle = {
  color: '#fff',
  background: 'linear-gradient(to right, #16a34a, #15803d, #16a34a)',
  boxShadow: '0 4px 6px -1px rgba(22, 163, 74, 0.5), 0 2px 4px -2px rgba(22, 163, 74, 0.5)',
  border: 'none',
  borderRadius: "5px",
  cursor: 'pointer',
  transition: 'all 0.3s ease',
}

const ViewonMouseEnter = (e) => {
  e.currentTarget.style.background = 'linear-gradient(to bottom right, #16a34a, #15803d)';
}

const ViewonMouseLeave = (e) => {
  e.currentTarget.style.background = 'linear-gradient(to right, #16a34a, #15803d, #16a34a)';
}

const ViewonFocus = (e) => {
  e.currentTarget.style.outline = 'none';
  e.currentTarget.style.boxShadow = '0 0 0 4px rgba(21, 128, 61, 0.5)';
}

const ViewonBlur = (e) => {
  e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(22, 163, 74, 0.5), 0 2px 4px -2px rgba(22, 163, 74, 0.5)';
}

export {
  HeroImages,
  navItems,
  countUpData,
  FotterText,
  socialMedia,


  AdminLinks,
  localeTextGrid,
  DeletButtonStyle,
  DeleteonMouseEnter,
  DeleteonMouseLeave,
  DeleteonFocus,
  DeleteonBlur,
  EditButtonStyle,
  EditonMouseEnter,
  EditonMouseLeave,
  EditonFocus,
  EditonBlur,
  ViewButtonStyle,
  ViewonMouseEnter,
  ViewonMouseLeave,
  ViewonFocus,
  ViewonBlur,

  
};
